import { Route, Routes } from "react-router-dom";

import { PermissionEnum } from "@/utils/enums/PermissionEnum";
import { Restrict } from "@/components/Restrict";
import { FormTrackFile } from "@/pages/app/TrackListManagement/FormTrackFile";
import { TrackListDetails } from "@/pages/app/TrackListManagement/TrackListDetails";
import { FormTrackList } from "@/pages/app/TrackListManagement/FormTrackList";
import { TrackListManagement } from "@/pages/app/TrackListManagement";
import { StorageManagement } from "@/pages/app/StorageManagement";
import { AccessProfiles } from "@/pages/app/AccessProfiles";
import { CitiesManagement } from "@/pages/app/CitiesManagement";
import { CityAdminReport } from "@/pages/app/CityAdminReport";
import { DatabaseManagement } from "@/pages/app/DatabaseManagement";

export function AdminRoutes() {
	return (
		<Routes>
			<Route
				path="/configuracoes/cidades"
				element={
					<Restrict redirectIfNotAuthorized>
						<CitiesManagement />
					</Restrict>
				}
			/>
			<Route
				path="/configuracoes/gestao-de-perfil"
				element={
					<Restrict redirectIfNotAuthorized>
						<AccessProfiles />
					</Restrict>
				}
			/>
			<Route
				path="/configuracoes/banners"
				element={
					<Restrict permissions={[PermissionEnum.SUPER_ADMIN]} redirectIfNotAuthorized>
						<StorageManagement />
					</Restrict>
				}
			/>
			<Route
				path="/configuracoes/track-lists"
				element={
					<Restrict permissions={[PermissionEnum.SUPER_ADMIN]} redirectIfNotAuthorized>
						<TrackListManagement />
					</Restrict>
				}
			/>
			<Route
				path="/configuracoes/track-lists/novo"
				element={
					<Restrict permissions={[PermissionEnum.SUPER_ADMIN]} redirectIfNotAuthorized>
						<FormTrackList />
					</Restrict>
				}
			/>
			<Route
				path="/configuracoes/track-lists/:trackListId"
				element={
					<Restrict permissions={[PermissionEnum.SUPER_ADMIN]} redirectIfNotAuthorized>
						<TrackListDetails />
					</Restrict>
				}
			/>
			<Route
				path="/configuracoes/track-lists/:trackListId/novo"
				element={
					<Restrict permissions={[PermissionEnum.SUPER_ADMIN]} redirectIfNotAuthorized>
						<FormTrackFile />
					</Restrict>
				}
			/>
			<Route
				path="/relatorios/admin/cidade"
				element={
					<Restrict redirectIfNotAuthorized>
						<CityAdminReport />
					</Restrict>
				}
			/>
			<Route
				path="/configuracoes/banco-de-dados"
				element={
					<Restrict redirectIfNotAuthorized>
						<DatabaseManagement />
					</Restrict>
				}
			/>
		</Routes>
	);
}
